import { z } from 'zod';

export const placeABidFormSchema = z.object({
  price: z.number(),
  maxPrice: z.number().optional(),
  termsAndConditions: z.boolean().refine((value) => value === true, {
    message: 'You must agree to the terms and conditions',
  }),
  shippingAddress: z.string(),
  shippingCost: z.number(),
  paymentMethodId: z.string(),
  tax: z.number(),
});
export type PlaceABidForm = z.infer<typeof placeABidFormSchema>;

export const placeABidSteps = [
  'bid-price',
  'shipping-payment',
  'review-bid',
] as const;
export type PlaceABidStep = (typeof placeABidSteps)[number];

export const updateBidFormSchema = z.object({
  price: z.number(),
  maxPrice: z.number().optional(),
});
export type UpdateBidFormSchemaType = z.infer<typeof updateBidFormSchema>;
